import * as React from 'react';

const Wallet24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M17 13.526a1 1 0 1 0 0-2 1 1 0 0 0 0 2" }), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M4.25 5.526h17c.41 0 .75.34.75.75v13.5c0 .41-.34.75-.75.75h-17c-1.24 0-2.25-1.01-2.25-2.25v-13.5c0-1.24 1.01-2.25 2.25-2.25h15c.41 0 .75.34.75.75s-.34.75-.75.75h-15c-.41 0-.75.34-.75.75s.34.75.75.75m-.75 1.5v11.25c0 .41.34.75.75.75H20.5v-12z"
  }
));
Wallet24.Size = 24;
Wallet24.Title = "Wallet";

export { Wallet24 as default };
